/** Catálogo de telas (chave estável + rota). Deve coincidir com o backend. */
export const SCREEN_CATALOG = [
  { key: "dashboard", path: "/dashboard", label: "Dashboard" },
  { key: "lojas", path: "/lojas", label: "Lojas" },
  { key: "usuarios", path: "/usuarios", label: "Usuários" },
  { key: "entregadores", path: "/entregadores", label: "Entregadores" },
  { key: "estatisticas", path: "/estatisticas", label: "Estatísticas" },
  { key: "relatorios", path: "/relatorios", label: "Relatórios (menu)" },
  {
    key: "relatorios_pizzas_por_sabor",
    path: "/relatorios/pizzas-por-sabor",
    label: "Relatório — Pizzas por sabor",
  },
  {
    key: "relatorios_pizzas_por_tamanho",
    path: "/relatorios/pizzas-por-tamanho",
    label: "Relatório — Pizzas por tamanho",
  },
  {
    key: "relatorios_pizzas_brinde",
    path: "/relatorios/pizzas-brinde",
    label: "Relatório — Pizzas brinde",
  },
  {
    key: "relatorios_pizzas_promocoes",
    path: "/relatorios/pizzas-promocoes",
    label: "Relatório — Promoções",
  },
  {
    key: "relatorios_pedidos_por_bairro",
    path: "/relatorios/pedidos-por-bairro",
    label: "Relatório — Pedidos por bairro",
  },
  {
    key: "relatorios_bebidas",
    path: "/relatorios/bebidas",
    label: "Relatório — Bebidas",
  },
  {
    key: "relatorios_rodizio_pizzas",
    path: "/relatorios/rodizio-pizzas",
    label: "Relatório — Rodízio de Pizzas",
  },
  {
    key: "relatorios_salao_pizzas",
    path: "/relatorios/salao-pizzas",
    label: "Relatório — Pizzas Salão",
  },
  {
    key: "relatorios_salao_bebidas",
    path: "/relatorios/salao-bebidas",
    label: "Relatório — Bebidas Salão",
  },
  { key: "historicos", path: "/historicos", label: "Históricos" },
  {
    key: "historico_pulo_borda",
    path: "/historico-pulo-borda",
    label: "Histórico — pulo por falta de borda",
  },
  {
    key: "limpeza_pendentes",
    path: "/limpeza-pendentes",
    label: "Limpeza — pendentes excluídos",
  },
  { key: "metas_coletiva", path: "/metas/coletiva", label: "Meta coletiva" },
  {
    key: "metas_individual",
    path: "/metas/individual",
    label: "Meta individual",
  },
  { key: "meu_perfil", path: "/meu-perfil", label: "Meu perfil" },
  { key: "pizzaiolo", path: "/pizzaiolo", label: "Produção (pizzaiolo)" },
  {
    key: "pizzaiolo_integracao",
    path: "/pizzaiolo-integracao",
    label: "Produção integração",
  },
  { key: "forneiro", path: "/forneiro", label: "Forno" },
  {
    key: "producao_porcoes",
    path: "/producao-porcoes",
    label: "Produção Porções",
  },
  {
    key: "producao_bebidas",
    path: "/producao-bebidas",
    label: "Produção Bebidas",
  },
  { key: "bordeiro", path: "/bordeiro", label: "Bordeiro" },
  {
    key: "painel_bordeiro",
    path: "/painel-bordeiro",
    label: "Painel Bordeiro",
  },
  { key: "roterista", path: "/roterista", label: "Roteirista" },
  {
    key: "roterista_automatico",
    path: "/roterista-automatico",
    label: "Roteirista Automático",
  },
  {
    key: "ranking_producao",
    path: "/ranking/producao",
    label: "TV — Produções",
  },
  {
    key: "ranking_montagem",
    path: "/ranking/montagem",
    label: "TV — Montagens",
  },
  {
    key: "ranking_entregas",
    path: "/ranking/entregas",
    label: "TV — Entregas",
  },
  {
    key: "ranking_metas_coletiva",
    path: "/ranking/metas-coletiva",
    label: "TV — Metas coletiva",
  },
  {
    key: "ranking_painel_bordeiro",
    path: "/ranking/painel-bordeiro",
    label: "TV — Painel Bordeiro",
  },
  {
    key: "ranking_metricas_qualidade",
    path: "/ranking/metricas-qualidade",
    label: "TV — Métricas de qualidade",
  },
  {
    key: "ranking_retirada",
    path: "/ranking/retirada",
    label: "TV — Retiradas",
  },
  {
    key: "ranking_ficha_diaria",
    path: "/ranking/ficha-diaria",
    label: "TV — Ficha Diária",
  },
  {
    key: "ranking_ficha_setores",
    path: "/ranking/ficha-setores",
    label: "TV — Setores",
  },
  { key: "cardapio", path: "/cardapio", label: "Cardápio" },
  { key: "bordas", path: "/bordas", label: "Bordas" },
  { key: "tamanhos", path: "/tamanhos", label: "Tamanhos" },
  {
    key: "filas_integracao",
    path: "/filas-integracao",
    label: "Filas integração",
  },
  {
    key: "fila_porcoes",
    path: "/fila-porcoes",
    label: "Fila de porções",
  },
  {
    key: "fila_bebidas",
    path: "/fila-bebidas",
    label: "Fila de bebidas",
  },
  {
    key: "rodizio",
    path: "/rodizio",
    label: "Rodízio — Sequência",
  },
  {
    key: "rodizio_urgencia",
    path: "/rodizio/urgencia",
    label: "Rodízio — Urgência",
  },
  {
    key: "aguardando_entrega",
    path: "/aguardando-entrega",
    label: "Aguardando entrega",
  },
  { key: "painel", path: "/painel", label: "Painel" },
  {
    key: "sequencia_pedidos",
    path: "/sequencia-pedidos",
    label: "Sequência do dia",
  },
  { key: "inspecao", path: "/inspecao", label: "Inspeção" },
  { key: "whatsapp", path: "/whatsapp", label: "WhatsApp" },
  {
    key: "webhooks_cardapio",
    path: "/webhooks/cardapio",
    label: "Webhooks cardápio",
  },
  {
    key: "configuracao_acessos",
    path: "/perfis/permissoes",
    label: "Perfis e permissões",
  },
  {
    key: "atualizar_apk",
    path: "/atualizar-apk",
    label: "Atualizar APK (app)",
  },
  {
    key: "mensagens_mobile",
    path: "/mensagens-mobile",
    label: "Mensagens mobile (app)",
  },
  {
    key: "controle_producao_setores",
    path: "/controle-producao/setores",
    label: "Controle de Produção — Setores",
  },
  {
    key: "controle_producao_itens",
    path: "/controle-producao/itens",
    label: "Controle de Produção — Itens",
  },
  {
    key: "controle_producao_base_semanal",
    path: "/controle-producao/base-semanal",
    label: "Controle de Produção — Base Semanal",
  },
  {
    key: "controle_producao_funcionamento",
    path: "/controle-producao/funcionamento",
    label: "Controle de Produção — Funcionamento",
  },
  {
    key: "controle_producao_ficha_diaria",
    path: "/controle-producao/ficha-diaria",
    label: "Controle de Produção — Ficha Diária",
  },
  {
    key: "controle_producao_ficha_transferencia",
    path: "/controle-producao/ficha-transferencia",
    label: "Controle de Produção — Ficha de Transferência",
  },
  {
    key: "controle_producao_sobras",
    path: "/controle-producao/sobras",
    label: "Controle de Produção — Sobras",
  },
  {
    key: "controle_producao_und_medida",
    path: "/controle-producao/und-medida",
    label: "Controle de Produção — Unidades de Medida",
  },
  {
    key: "controle_producao_relatorio_consumo",
    path: "/controle-producao/relatorio-consumo",
    label: "Controle de Produção — Relatório Consumo",
  },
  {
    key: "controle_producao_relatorio_tempos",
    path: "/controle-producao/relatorio-tempos",
    label: "Controle de Produção — Desempenho",
  },
  {
    key: "controle_producao_relatorio_equipe",
    path: "/controle-producao/relatorio-equipe",
    label: "Controle de Produção — Equipe por Setor",
  },
  {
    key: "ferramentas_desenvolvedor",
    path: "/ferramentas-desenvolvedor",
    label: "Ferramentas de desenvolvedor",
  },
  {
    key: "monitoramento_servidor",
    path: "/monitoramento",
    label: "Monitoramento do servidor",
  },
  {
    key: "backups_servidor",
    path: "/backups",
    label: "Backups do servidor",
  },
  {
    key: "crons_servidor",
    path: "/crons",
    label: "Crons do servidor",
  },
] as const;

const PATH_ROWS = [...SCREEN_CATALOG].sort(
  (a, b) => b.path.length - a.path.length
);

export function pathToScreenKey(pathname: string): string | null {
  for (const row of PATH_ROWS) {
    if (pathname === row.path || pathname.startsWith(`${row.path}/`)) {
      return row.key;
    }
  }
  return null;
}
